// @mui
import { alpha, styled } from '@mui/material/styles';
import { ListItemIcon, ListSubheader, ListItemButton } from '@mui/material';
// config
import { ICON, NAV } from '../../../config-global';

// ----------------------------------------------------------------------

export const StyledItem = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'active' && prop !== 'caption',
})(({ active, disabled, depth, caption, theme }) => {
  const subItem = depth !== 1;

  const activeStyle = {
    color: '#FFFFFF',
    backgroundColor: alpha('#FFFFFF', 0.1),
    '& .MuiListItemIcon-root': {
      color: '#F5C451',
    },
  };

  const activeSubStyle = {
    color: '#FFFFFF',
    backgroundColor: alpha('#FFFFFF', 0.07),
  };

  return {
    position: 'relative',
    textTransform: 'capitalize',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1.5),
    marginBottom: theme.spacing(0.75),
    color: alpha('#FFFFFF', 0.76),
    borderRadius: 14,
    height: NAV.H_DASHBOARD_ITEM,
    transition: theme.transitions.create(
      ['background-color', 'border-color', 'color', 'box-shadow', 'transform'],
      { duration: theme.transitions.duration.shorter }
    ),
    '& .MuiListItemIcon-root': {
      color: alpha('#D6F2FF', 0.72),
      transition: theme.transitions.create('color'),
    },
    '&:hover': {
      color: '#FFFFFF',
      backgroundColor: alpha('#FFFFFF', 0.07),
      '& .MuiListItemIcon-root': {
        color: '#D6F2FF',
      },
    },
    // Sub item
    ...(subItem && {
      height: NAV.H_DASHBOARD_ITEM_SUB,
      ...(depth > 2 && {
        paddingLeft: theme.spacing(depth),
      }),
      ...(caption && {
        height: NAV.H_DASHBOARD_ITEM,
      }),
    }),
    // Active item
    ...(active && {
      ...activeStyle,
      '&:hover': {
        ...activeStyle,
      },
    }),
    // Active sub item
    ...(subItem &&
      active && {
        ...activeSubStyle,
        '&:hover': {
          ...activeSubStyle,
        },
      }),
    // Disabled
    ...(disabled && {
      '&.Mui-disabled': {
        opacity: 0.64,
      },
    }),
  };
});

// ----------------------------------------------------------------------

export const StyledIcon = styled(ListItemIcon)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: ICON.NAV_ITEM,
  height: ICON.NAV_ITEM,
});

// ----------------------------------------------------------------------

export const StyledDotIcon = styled('span', {
  shouldForwardProp: (prop) => prop !== 'active',
})(({ active, theme }) => ({
  width: 5,
  height: 5,
  borderRadius: '50%',
  backgroundColor: alpha('#D6F2FF', 0.55),
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shorter,
  }),
  ...(active && {
    transform: 'scale(2)',
    backgroundColor: '#F2B632',
  }),
}));

// ----------------------------------------------------------------------

export const StyledSubheader = styled(ListSubheader)(({ theme }) => ({
  ...theme.typography.overline,
  fontSize: 11,
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(1),
  color: alpha('#FFFFFF', 0.52),
  backgroundColor: 'transparent',
  letterSpacing: 0.6,
}));
